import Util from "@/helper/Utility.js";

export function SerialModel() {
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.currentTimestamp = '';
    this.expireIn = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.redeemTimestamp = '';
    this.serial = '';
    this.serialType = '';
    this.showTimer = false;
    this.expiresDate = null
    this.localeCode = 1054; // default as thai
    this.isUsed = false;

    /**
     * @param {import("@/core/Campaign/model/CampaignModel").default} campaign /core/Campaign/model/CampaignModel.js
     */
    this.setModelFromDataModel = function (campaign) {
        // console.log(this.localeCode, campaign)
        this.campaignImgUrl = campaign.fullImageUrl || '';
        this.campaignName = campaign.name || '';
        if (this.localeCode == 1033) {
            this.campaignName = campaign.nameEn || campaign.name
        } else if (this.localeCode == 1054) {
            this.campaignName = campaign.nameTh || campaign.name
        } else {
            this.campaignName = campaign.name || '';
        }
        this.expireIn = campaign.expireIn || 0;
        this.privilegeMessage = campaign.privilegeMessage || '';
        this.privilegeMessageFormat = campaign.privilegeMessageFormat | '';
        this.redeemTimestamp = campaign.redeemDate || '';
        this.serial = campaign.serial || '';
        this.expiresDate = campaign.expireDate || null;

        if (this.expiresDate == null) {
            this.expiresDate = campaign.voucherExpireDate || null
        }

        this.serialType = campaign.barcode || '';
        if (Util.isNumber(campaign.minutesValidAfterUsed) && campaign.minutesValidAfterUsed > 0) {
            this.showTimer = true;
        }
        
        this.isUsed = campaign.isUsed || false;
    };

    this.setLocaleCode = function (code) {
        this.localeCode = code
    }
}
